var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clipText"},[_c('el-tag',{ref:"tag",style:('min-width: ' + _vm.tabWidth),attrs:{"type":_vm.type}},[_vm._t("default")],2),_c('el-button',{staticClass:"clipText-btn",attrs:{"type":"text"},on:{"click":_vm.copyText}},[_c('i',{staticClass:"el-icon-copy-document"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }